var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.32 92.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M9.564 0C4.292 0 0 4.295 0 9.567v73.47c0 5.272 4.292 9.567 9.564 9.567h56.18c5.272 0 9.564-4.294 9.564-9.567V22.624s.15-1.769-.617-3.49c-.72-1.614-1.893-2.737-1.893-2.737a1.571 1.571 0 00-.01-.012L58.85 2.714a1.571 1.571 0 00-.023-.024S57.637 1.557 55.873.8C53.796-.09 51.655.003 51.655.003L51.687 0z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#ff2116",
    paintOrder: "markers fill stroke"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M9.564 3.143h42.123a1.571 1.571 0 00.032 0s1.684.016 2.916.545a7.993 7.993 0 012.032 1.284l.006.006 13.904 13.64s.838.884 1.244 1.795c.327.734.348 2.078.348 2.078a1.571 1.571 0 00-.003.067v60.48c0 3.585-2.836 6.424-6.422 6.424H9.564c-3.586 0-6.421-2.838-6.421-6.425V9.567c0-3.586 2.835-6.424 6.42-6.424z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#f5f5f5",
    paintOrder: "markers fill stroke"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.804 55.136c-2.162-2.162.177-5.133 6.526-8.288l3.994-1.986 1.557-3.405a134.054 134.054 0 002.838-6.79l1.283-3.385-.884-2.506c-1.087-3.08-1.474-7.71-.785-9.374.934-2.255 3.993-2.024 5.205.393.946 1.888.849 5.306-.272 9.618l-.92 3.534.81 1.375c.445.756 1.746 2.55 2.89 3.989l2.152 2.675 2.677-.349c8.503-1.11 11.416.776 11.416 3.48 0 3.413-6.677 3.695-12.285-.243-1.261-.886-2.127-1.767-2.127-1.767s-3.513.715-5.243 1.182c-1.785.48-2.675.782-5.29 1.665 0 0-.918 1.332-1.516 2.3-2.224 3.605-4.821 6.591-6.676 7.678-2.077 1.217-4.254 1.3-5.35.204zm3.393-1.212c1.216-.751 3.676-3.661 5.378-6.361l.69-1.094-3.14 1.579c-4.848 2.438-7.066 4.735-5.913 6.125.648.78 1.423.716 2.985-.25zm31.494-8.84c1.189-.833 1.016-2.511-.328-3.188-1.045-.526-1.888-.634-4.606-.594-1.67.114-4.354.45-4.81.553 0 0 1.476 1.019 2.13 1.394.872.498 2.99 1.422 4.537 1.895 1.526.467 2.409.418 3.077-.06zM41.028 39.82c-.72-.756-1.943-2.334-2.719-3.507-1.014-1.331-1.523-2.27-1.523-2.27s-.742 2.385-1.35 3.82l-1.898 4.692-.55 1.064s2.925-.959 4.414-1.348c1.576-.411 4.776-1.04 4.776-1.04zm-4.081-16.365c.183-1.54.261-3.078-.233-3.853-1.373-1.5-3.03-.25-2.749 3.317.095 1.2.393 3.251.791 4.516l.725 2.298.51-1.73c.28-.953.71-3 .956-4.548z",
    fill: "#ff2116"
  })), /*#__PURE__*/React.createElement("g", {
    fontWeight: 400,
    fontFamily: "Franklin Gothic Medium Cond",
    letterSpacing: 0,
    wordSpacing: 4.26,
    fill: "#2c2c2c"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "125%",
      InkscapeFontSpecification: "'Franklin Gothic Medium Cond'"
    },
    d: "M22.48 65.148h3.511q1.683 0 2.732.322 1.049.312 1.765 1.403.717 1.08.717 2.606 0 1.402-.582 2.41-.581 1.007-1.568 1.454-.976.446-3.012.446h-1.215v5.536h-2.347zm2.348 1.818v4.944h1.163q1.558 0 2.15-.582.602-.582.602-1.89 0-.976-.394-1.579-.395-.613-.873-.748-.467-.145-1.485-.145zM33.002 65.148h3.188q2.316 0 3.697.821 1.392.82 2.098 2.44.717 1.62.717 3.594 0 2.077-.644 3.708-.634 1.62-1.953 2.617-1.308.997-3.738.997h-3.365zm2.347 1.88v10.417h.976q2.046 0 2.97-1.412.925-1.423.925-3.791 0-5.214-3.895-5.214zM44.956 65.148h7.872v1.88h-5.525v4.238h4.424v1.88h-4.424v6.179h-2.347z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDF_icon.0dffa8ff336068d22ca5283f879f4ee7.svg";
export { ForwardRef as ReactComponent };